import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=5961c9bc&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=5961c9bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961c9bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5961c9bc')) {
      api.createRecord('5961c9bc', component.options)
    } else {
      api.reload('5961c9bc', component.options)
    }
    module.hot.accept("./AddModal.vue?vue&type=template&id=5961c9bc&scoped=true", function () {
      api.rerender('5961c9bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/add-student/AddModal.vue"
export default component.exports